<template>
  <v-container grid-list-lg>
    <m-breadcrum :items="bread"></m-breadcrum>

    <v-row wrap v-if="jamKerja">
      <v-col cols="12" md="12" sm="12">
        <m-card
          :title="title"
          :edit="!this.keyAkses && Number(jamKerja.k_tipe_jadwal) === 1 ? false : isCan(`jadwal.${keyAkses}update`)"
          @edit="edit"
          class="ma-5"
        >
          <v-row wrap>
            <v-col cols="12" sm="12" md="6">
              <v-list>
                <m-list-tile-info label="Tipe" class="px-0" :value="jamKerja.tipe_jadwal" />
                <m-list-tile-info class="px-0"
                  label="Deskripsi"
                  :value="jamKerja.keterangan"
                />
              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list>
                <!-- <v-subheader class="title green--text">JADWAL {{jamKerja.nama}}</v-subheader>
                <v-divider></v-divider>-->
                <m-list-tile-info class="px-0"
                  label="Awal Berlaku"
                  :value="jamKerja.tgl_berlaku | toSDN"
                />
                <m-list-tile-info class="px-0"
                  label="Akhir Berlaku"
                  :value="jamKerja.tgl_berakhir | toSDN"
                />
              </v-list>
            </v-col>
            <v-col cols="12" md="12">
              <v-list>
                <v-divider></v-divider>
                <v-row wrap v-if="jamKerja">
                  <v-col cols="12" md="12">
                    <m-card-list
                      title="Detail Jam kerja"
                      :items="jamKerja.detail_jam_kerja"
                      @refresh="load"
                      :headers="headers"
                      footer
                    >
                      <template v-slot:items="{ props, item }">
                        <tr>
                          <td>{{ item.hari }}</td>
                          <td class="">
                            <span>
                              {{
                                $setTimezone(item.jam_datang, 2) | formatTime
                              }}
                              -
                              <template v-if="jamKerja.k_jenis_presensi !== 1">
                                {{
                                  $setTimezone(item.jam_pulang, 2) | formatTime
                                }}
                              </template>
                              <template v-else>
                                {{
                                  $setTimezone(item.batas_jam_datang_akhir, 2) | formatTime
                                }}
                              </template>
                            </span>
                          </td>
                          <td class="">
                            <span v-if="jamKerja.k_jenis_presensi !== 1">
                              {{
                                $setTimezone(item.jam_istirahat_mulai, 2)
                                  | formatTime
                              }}
                              -
                              {{
                                $setTimezone(item.jam_istirahat_selesai, 2)
                                  | formatTime
                              }}
                            </span>
                            <template v-else>
                              <div class=" blue lighten-4" style="width: 130px">
                              <span class="caption px-1">
                                Masuk :
                                {{
                                  $setTimezone(item.jam_datang, 3)
                                }}
                              </span>
                              </div>
                              <div class="orange lighten-4" style="width: 130px">
                              <span class="caption px-1">
                                Keluar :
                                {{
                                  $setTimezone(item.batas_jam_datang_akhir, 3)
                                }}
                              </span>
                              </div>
                            </template>
                          </td>
                          <td v-if="jamKerja.k_jenis_presensi !== 1">
                            <div class=" blue lighten-4">
                              <span class="caption px-1">
                                Masuk :
                                {{
                                  $setTimezone(item.batas_jam_datang_mulai, 3)
                                }}
                                -
                                {{
                                  $setTimezone(item.batas_jam_datang_akhir, 3)
                                }}
                              </span>
                            </div>
                            <div class="orange lighten-4">
                              <span class="caption px-1">
                                Keluar :
                                {{
                                  $setTimezone(item.batas_jam_pulang_mulai, 3)
                                }}
                                -
                                {{
                                  $setTimezone(item.batas_jam_pulang_akhir, 3)
                                }}
                              </span>
                            </div>
                          </td>

                          <td v-if="jamKerja.k_jenis_presensi !== 1" class="">{{ item.toleransi_datang }}</td>
                          <td v-if="jamKerja.k_jenis_presensi !== 1" class="">{{ item.toleransi_pulang }}</td>
                        </tr>
                      </template>
                    </m-card-list>
                  </v-col>
                </v-row>
              </v-list>
            </v-col>
          </v-row>
        </m-card>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>
<script>
import ChangeDlg from "../components/FormJamKerja.vue";
import { KONVERSI_JAM } from "@/modules/jamKerja/const";
export default {
  components: { ChangeDlg },
  data() {
    return {
      jamKerja: null,
      title: "",
    };
  },
  computed: {
    headers() {
      let temp = []

      if (this.jamKerja.k_jenis_presensi === 1) {
        temp = [
          { text: "Hari", align: "left", value: "hari", sortable: false },
          { text: "Jam Kerja", value: "jam_datang" },
          { text: "Batas Scan", value: "batas_scan" },
        ]
      } else {
        temp = [
          { text: "Hari", align: "left", value: "hari", sortable: false },
          { text: "Jam Kerja", value: "jam_datang" },
          { text: "Jam Istirahat", value: "jam_istirahat_mulai" },
          { text: "Batas Scan", value: "batas_scan" },
          { text: "Toleransi Masuk", value: "toleransi_datang" },
          { text: "Toleransi Keluar", value: "toleransi_pulang" }
        ]
      }

      return temp
    },

    bread() {
      let params = {}
      if (this.organisasi_id) {
        params = {
          name: 'jamKerja',
          params: { organisasi_id: this.organisasi_id }
        }
      } else {
        params = {
          name: 'tenant-jamKerja',
          params: { tenant_id: this.tenant_id }
        }
      }

      return [
        {
          icon: "mdi-briefcase-clock",
          title: "Jam Kerja",
          to: params
        },
        {
          icon: "mdi-clock",
          title: this.jamKerja && this.jamKerja.nama,
        }
      ];
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if (!this.$route.params.jadwal_id) return;
      this.$store
        .dispatch("jamKerja/detail", this.$route.params.jadwal_id)
        .then(res => {
          this.title = res.data.nama;
          this.jamKerja = res.data;
        })
        .catch(e => e);
    },
    edit() {
      const jamKerja = [
        ...((this.jamKerja && this.jamKerja.detail_jam_kerja) || [])
      ];
      let detail_jam_kerja = [];
      jamKerja.forEach(item => {
        let temp = {};
        Object.keys(item).forEach(key => {
          if (KONVERSI_JAM.includes(key)) {
            this.$set(temp, key, this.$setTimezone(item[key], 3));
          } else {
            this.$set(temp, key, item[key]);
          }
        });
        detail_jam_kerja.push(temp);
      });

      let obj = Object.assign({}, this.jamKerja, {
        detail_jam_kerja: detail_jam_kerja
      });
      this.$refs.dlg.open(obj).then(() => {
        this.load();
      });
    },
    close() {
      this.$router.push({
        name: "jamKerja"
      });
    }
  },

  watch: {
    "$route.params.jadwal_id": "load"
  }
};
</script>
